export const classes = {
  wrapper:
    'inline-flex items-center gap-[3px] rounded-[13px] border border-black/10 bg-white/50 p-1 dark:border-white/10 dark:bg-white/[0.05]',
};
